"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var hovo_api_1 = require("../../shared/hovo-api");
var form_1 = require("../../shared/form");
var arrays_1 = require("../../shared/arrays");
var course_filtering_1 = require("./course-filtering");
var course_filter_state_1 = require("./course-filter-state");
var filtersPromise;
(0, jquery_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var $filters;
    return __generator(this, function (_a) {
        $filters = (0, jquery_1.default)('.course-filters');
        if (!$filters.length) {
            return [2 /*return*/];
        }
        $filters.each(function () {
            var $filter = (0, jquery_1.default)(this);
            var $selectedFilters = $filter.parent().find('.selected-filters');
            var $isOnlineCheck = $filter.find("input[name='is_online']");
            var initialFieldFilter = (0, jquery_1.default)('#courses-list').attr("data-initial-field-filter");
            var savedSelection = (0, course_filter_state_1.loadCourseFilters)();
            var initialSelectionApplied = false;
            var dropdowns = [
                { field: "dag", $element: $filter.find("select[name='dag']"), selected: [] },
                { field: "locatie", $element: $filter.find("select[name='locatie']"), selected: [] },
                { field: "seizoen", $element: $filter.find("select[name='seizoen']"), selected: [] },
                { field: "vakgebied", $element: $filter.find("select[name='vakgebied']"), selected: [] },
                { field: "cursus", $element: $filter.find("select[name='cursusaanbod']"), selected: [] }
            ];
            function getSelection() {
                var selection = { is_online: $isOnlineCheck.is(':checked') };
                for (var _i = 0, dropdowns_2 = dropdowns; _i < dropdowns_2.length; _i++) {
                    var dropdown = dropdowns_2[_i];
                    selection[dropdown.field] = dropdown.selected.map(function (item) { return item.value; });
                }
                return selection;
            }
            function loadCourses() {
                var selection = getSelection();
                (0, course_filter_state_1.saveCourseFilters)(selection);
                (0, jquery_1.default)(document).trigger("courseFilterChanged", [selection]);
            }
            function renderSelectedFilters() {
                $selectedFilters.find('.selected-filter').remove();
                function addTag(field, title, clear) {
                    var $tag = (0, jquery_1.default)('<div class="selected-filter" role="button" tabindex="0"></div>')
                        .addClass("selected-filter-".concat(field))
                        .text("x ".concat(title));
                    function remove() {
                        clear();
                        renderSelectedFilters();
                        loadCourses();
                    }
                    $tag.on('click', remove);
                    $tag.on('keydown', function (event) {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            remove();
                        }
                    });
                    $selectedFilters.append($tag);
                }
                var _loop_2 = function (dropdown) {
                    var _loop_3 = function (item) {
                        addTag(dropdown.field, item.title, function () {
                            dropdown.selected = dropdown.selected.filter(function (selected) { return selected.value !== item.value; });
                        });
                    };
                    for (var _a = 0, _b = dropdown.selected; _a < _b.length; _a++) {
                        var item = _b[_a];
                        _loop_3(item);
                    }
                };
                for (var _i = 0, dropdowns_3 = dropdowns; _i < dropdowns_3.length; _i++) {
                    var dropdown = dropdowns_3[_i];
                    _loop_2(dropdown);
                }
                if ($isOnlineCheck.is(':checked')) {
                    addTag("is_online", $isOnlineCheck.parent().parent().text().trim(), function () { return $isOnlineCheck.prop('checked', false); });
                }
            }
            var _loop_1 = function (dropdown) {
                dropdown.$element.on('change', function () {
                    var value = dropdown.$element.val();
                    if (typeof value !== "string" || !value) {
                        return;
                    }
                    if (!dropdown.selected.some(function (item) { return item.value === value; })) {
                        dropdown.selected.push({ value: value, title: dropdown.$element.find(':selected').text() });
                    }
                    dropdown.$element.val('');
                    renderSelectedFilters();
                    loadCourses();
                });
            };
            for (var _i = 0, dropdowns_1 = dropdowns; _i < dropdowns_1.length; _i++) {
                var dropdown = dropdowns_1[_i];
                _loop_1(dropdown);
            }
            $isOnlineCheck.on('change', function () {
                renderSelectedFilters();
                loadCourses();
            });
            function initializeSelectBoxes(courses) {
                return __awaiter(this, void 0, void 0, function () {
                    var filters, courseFormat, itemsByField, selectionAdded, _loop_4, _i, dropdowns_4, dropdown, fieldDropdown, field, selection, _loop_5, _a, dropdowns_5, dropdown;
                    var _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                filtersPromise = filtersPromise !== null && filtersPromise !== void 0 ? filtersPromise : (0, hovo_api_1.getFilters)();
                                return [4 /*yield*/, filtersPromise];
                            case 1:
                                filters = _d.sent();
                                courseFormat = ((_b = dropdowns.find(function (dropdown) { return dropdown.field === "cursus"; })) === null || _b === void 0 ? void 0 : _b.$element.data("course-filter-formatting")) || "{TITLE}";
                                itemsByField = {
                                    dag: filters.days.map(function (day) { return ({ title: day, value: day }); }),
                                    locatie: filters.cities.map(function (city) { return ({ title: city.title, value: String(city.id) }); }),
                                    seizoen: filters.seasons.map(function (season) { return ({ title: season.title, value: String(season.id) }); }),
                                    vakgebied: filters.fields.map(function (field) { return ({ title: field.title, value: String(field.id) }); }),
                                    cursus: filters.courses.map(function (course) {
                                        var _a;
                                        return ({
                                            title: courseFormat.replace("{TITLE}", course.title)
                                                .replace("{COURSE_NUMBER}", String((_a = course.course_number) !== null && _a !== void 0 ? _a : "")),
                                            value: String(course.id)
                                        });
                                    })
                                };
                                selectionAdded = false;
                                if (!initialSelectionApplied) {
                                    initialSelectionApplied = true;
                                    if (savedSelection) {
                                        _loop_4 = function (dropdown) {
                                            var selection_1 = savedSelection[dropdown.field];
                                            var values = Array.isArray(selection_1) ? selection_1 : [selection_1];
                                            dropdown.selected = (0, arrays_1.distinct)(values
                                                .filter(function (value) { return value !== undefined && value !== ""; }).map(String))
                                                .map(function (value) {
                                                var _a, _b;
                                                return ({
                                                    value: value,
                                                    title: (_b = (_a = itemsByField[dropdown.field].find(function (item) { return item.value === value; })) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : value
                                                });
                                            });
                                        };
                                        for (_i = 0, dropdowns_4 = dropdowns; _i < dropdowns_4.length; _i++) {
                                            dropdown = dropdowns_4[_i];
                                            _loop_4(dropdown);
                                        }
                                        $isOnlineCheck.prop('checked', savedSelection.is_online === true);
                                    }
                                    else if (initialFieldFilter) {
                                        fieldDropdown = dropdowns.find(function (dropdown) { return dropdown.field === "vakgebied"; });
                                        field = filters.fields.find(function (item) { return String(item.id) === initialFieldFilter; });
                                        fieldDropdown === null || fieldDropdown === void 0 ? void 0 : fieldDropdown.selected.push({ value: initialFieldFilter, title: (_c = field === null || field === void 0 ? void 0 : field.title) !== null && _c !== void 0 ? _c : initialFieldFilter });
                                    }
                                    if (savedSelection || initialFieldFilter) {
                                        renderSelectedFilters();
                                        selectionAdded = true;
                                    }
                                }
                                selection = getSelection();
                                _loop_5 = function (dropdown) {
                                    // Ignore this dropdown's selections so additional OR choices remain available.
                                    var available = (0, course_filtering_1.filterCourses)(courses, selection, dropdown.field);
                                    var items = itemsByField[dropdown.field];
                                    var values = void 0;
                                    switch (dropdown.field) {
                                        case "dag":
                                            values = available.map(function (course) { return course.day; });
                                            break;
                                        case "locatie":
                                            values = available.flatMap(function (course) { var _a; return __spreadArray([course.city_id], ((_a = course.locations) !== null && _a !== void 0 ? _a : []).map(function (item) { var _a; return (_a = item.location) === null || _a === void 0 ? void 0 : _a.city_id; }), true); });
                                            break;
                                        case "seizoen":
                                            values = available.map(function (course) { return course.season_id; });
                                            break;
                                        case "vakgebied":
                                            values = available.map(function (course) { return course.field_id; });
                                            break;
                                        case "cursus":
                                            values = available.map(function (course) { return course.id; });
                                            break;
                                    }
                                    var allowed = (0, arrays_1.distinct)(values.filter(function (value) { return value != null; }).map(function (value) { return String(value); }));
                                    var placeholder = dropdown.$element.find('option[value=""]').text();
                                    var options = items.filter(function (item) {
                                        var _a;
                                        return allowed.includes((_a = item.value) !== null && _a !== void 0 ? _a : "") &&
                                            !dropdown.selected.some(function (selected) { return selected.value === item.value; });
                                    });
                                    (0, form_1.fillSelectByElement)(dropdown.$element, __spreadArray([{ title: placeholder, value: "" }], options, true));
                                    dropdown.$element.val('');
                                };
                                for (_a = 0, dropdowns_5 = dropdowns; _a < dropdowns_5.length; _a++) {
                                    dropdown = dropdowns_5[_a];
                                    _loop_5(dropdown);
                                }
                                return [2 /*return*/, selectionAdded];
                        }
                    });
                });
            }
            (0, jquery_1.default)(document).on("coursesInitialized", function (e, courses, availableCourses) {
                return __awaiter(this, void 0, void 0, function () {
                    var selectionAdded, $counter;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, initializeSelectBoxes(availableCourses !== null && availableCourses !== void 0 ? availableCourses : courses)];
                            case 1:
                                selectionAdded = _a.sent();
                                if (selectionAdded) {
                                    loadCourses();
                                    return [2 /*return*/];
                                }
                                $counter = $filter.find(".course-counter");
                                $counter.find(".count").text(courses.length);
                                $counter.show();
                                return [2 /*return*/];
                        }
                    });
                });
            });
        });
        return [2 /*return*/];
    });
}); });
